/** One campaign home for the sidebar, dashboard links and editor breadcrumb. */
export const useCampaignsPath = () => '/campaign'
